<template>
  <div>
    <validation-component
      ref="addressFormRef"
      :validation-condition="addressCondition">
      <!-- 联系地址 -->
      <template slot="province">
        <div class="province-box">
          <el-select class="province-select" v-model="formData.country" @change="handleCountryChange">
            <el-option v-for="(item) in REGISTRATION_OPTIONS" :key="item.value" :label="$t(item.label)" :value="item.value"></el-option>
          </el-select>
          <el-select v-if="formData.country === 'CN'" v-model="formData.province" class="province-select" @change="handleProvinceChange">
            <el-option v-for="(item) in provinceList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select v-if="formData.province" v-model="formData.city" class="province-select">
            <el-option v-for="(item) in cityList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </template>
    </validation-component>
    <div class="margin-top-20">
    <el-button
      style="width: 100%"
      type="primary"
      @click="onSubmit"
      >{{ $t("message.common.submit") }}</el-button>
    </div>
  </div>
</template>

<script>
import { GetCityList, GetProvinceList } from '@/api/common/provinces-cities';
import { ShowErrorMessage } from '@/components/modal/tips/message-tips';
import { REQUIRED, ENGLISH_NAME } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { REGISTRATION_OPTIONS } from '@/views/account/information/api/options';

export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ValidationComponent,
  },
  data() {
    return {
      REGISTRATION_OPTIONS,
      addressCondition: [
        {
          key: 'province',
          name: 'message.user.contactAddress',
          type: 'slot',
          defValue: '',
          isShowStar: true,
          description: 'message.user.contactAddressTips',
        },
        {
          key: 'address',
          name: '',
          type: 'input',
          defValue: '',
          isShowStar: true,
          maxLength: 100,
          placeholder: this.$t('message.validator.input', { input: this.$t('message.user.detailAddress') }),
        },
      ],
      formData: {
        country: '',
        province: '',
        city: '',
        addressEn: '',
      },
      provinceList: [],
      cityList: [],
    };
  },
  created() {
    if (`${this.info.businessType}` === '0') { // 付款商户时，新增字段
      this.addressCondition.push({
        key: 'addressEn',
        name: '',
        type: 'input',
        defValue: '',
        rule: [REQUIRED, ENGLISH_NAME],
        isShowStar: true,
        maxLength: 60,
        placeholder: this.$t('message.validator.input', { input: this.$t('message.user.detailAddressEn') }),
        validator: this.validateAddressEn,
      });
    }
  },
  mounted() {
    this.provinceList = GetProvinceList();
    this.$refs.addressFormRef.setItemValue('address', this.info.address || '');
    this.formData.country = this.info.country || '';
    this.formData.province = this.info.province || '';
    this.formData.city = this.info.city || '';
    if (this.formData.province) {
      this.cityList = GetCityList(this.formData.province);
    }
    if (`${this.info.businessType}` === '0') { // 付款商户时
      this.formData.addressEn = this.info.addressEn || '';
      this.$refs.addressFormRef.setItemValue('addressEn', this.info.addressEn);
    }
  },
  methods: {
    validateAddressEn(rule, value, callback) {
      // 必填验证
      if (!value || REQUIRED.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.input', { input: this.$t('message.user.detailAddressEn').toLowerCase() })));
        return;
      }
      if (!ENGLISH_NAME.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.inputEnglish')));
        return;
      }
      if (value.length < 10 || value.length >= 60) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '[10, 60)' })));
        return;
      }
      callback();
    },
    handleCountryChange(value) {
      if (value === 'HK') {
        this.formData.province = '';
        this.formData.city = '';
      }
    },
    handleProvinceChange(value) {
      this.formData.city = '';
      this.cityList = GetCityList(value);
    },
    async submit(check = true) {
      return new Promise((resolve, reject) => {
        this.$refs.addressFormRef.toFormValid((params) => {
          if (check && (!this.formData.country || (this.formData.country === 'CN' && (!this.formData.province || !this.formData.city)))) {
            ShowErrorMessage(this.$t('message.validator.select', { select: this.$t('message.user.contactAddress') }));
            reject(new Error('validate error'));
            return;
          }
          resolve({ ...this.formData, address: params.address, addressEn: params.addressEn });
        }, () => {
          reject(new Error('toFormValid error'));
        });
      });
    },
    async onSubmit() {
      try {
        const res = await this.submit();
        this.$emit('finish', res);
      } catch (err) {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.province-box {
  display: flex;
  align-items: center;

  .province-select {
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
